var UnweightedGraph = (function () {
    function UnweightedGraph() {
        this.edges = new Map();
    }
    UnweightedGraph.prototype.addEdgesForNode = function (node, neighbors) {
        this.edges.set(node, neighbors);
        return this;
    };
    UnweightedGraph.prototype.getNeighbors = function (node) {
        return this.edges.get(node) || [];
    };
    return UnweightedGraph;
}());
export { UnweightedGraph };
